var Branch = /** @class */ (function () {
    function Branch(props) {
        Object.assign(this, props);
    }
    return Branch;
}());
export { Branch };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Branches/Model.ts
// module id = 687
// module chunks = 0